export default "__VITE_ASSET__CYFR8z_N__"